export default function initAlternatingCards(key) {
  const alternatingCards = document.querySelectorAll(
    `[data-alternate='${key}']`
  );

  if (alternatingCards.length > 0) {
    let currentShowing = 0;
    // eslint-disable-next-line no-inner-declarations
    function showCurrent() {
      alternatingCards.forEach((task) => {
        task.style.opacity = 0;
        task.style.display = "block";
      });
      alternatingCards[currentShowing].style.opacity = 1;

      setTimeout(() => {
        if (currentShowing < alternatingCards.length - 1) {
          currentShowing++;
        } else {
          currentShowing = 0;
        }
        showCurrent();
      }, parseInt(alternatingCards[currentShowing].getAttribute("data-alternate-duration"), 10) || 5000);
    }

    showCurrent();
  }
}
